import { Fragment } from 'react';

import GoogleLogo from '@/assets/logos/google.svg';

import { toast } from '@/components/ui/toast';
import CustomImage from '@/components/ui/Image';
import { useLoginWithGoogle } from '../hooks/useUserLogin';
import { ButtonLoader, SubmitButton } from '@/components/ui/SubmitButton';

const SignInWithGoogle = () => {
  const { refetch: loginWithGoogle, isFetching } = useLoginWithGoogle();

  const handleLoginWithGoogle = async () => {
    try {
      const { data } = await loginWithGoogle();
      if (data?.data?.loginUrl) {
        window.location.href = data.data.loginUrl;
      } else {
        toast.error('Login URL not found in response');
      }
    } catch (error) {
      toast.error('Login failed:' + error);
    }
  };

  return (
    <Fragment>
      <SubmitButton
        variant='outline'
        size='lg'
        className='min-h-[60px] w-full cursor-pointer text-lg font-bold text-black'
        disabled={isFetching}
        onClick={handleLoginWithGoogle}
      >
        <CustomImage
          src={GoogleLogo}
          alt='Google Logo'
          width={20}
          height={20}
          className='mr-4'
        />
        <p>Sign in with Google</p>
        {isFetching && <ButtonLoader className='ml-4' />}
      </SubmitButton>
    </Fragment>
  );
};

export default SignInWithGoogle;
